import { SessionSiteSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { IWhoHasSeenThisViewAction } from '~src/spacesPlatform/models/actionNames';
import { SiteRolesUtil } from '~src/userManagement/services/resources/SiteRolesUtil';
import { IViewBase } from '~src/views/models/IViewInfo';

import { whoHasSeenThisView } from '../../../actions/WhoHasSeenThisViewAction';
import { IContentInfo } from '../../../models/IContentInfo';
import { getOwnerIdForView } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const WhoHasSeenThisViewEntityAction: IEntityAction<IContentInfo | IViewBase, IWhoHasSeenThisViewAction> = {
  name: EntityActionNames.WhoHasSeenThisView,
  translateName: Messages.whoHasSeenThisView,
  isVisible: (targetItems: IContentInfo[]) => targetItems.length === 1,
  isClickable: (availableActions: IWhoHasSeenThisViewAction, targetItems: IContentInfo[] | IViewBase[], state: AppState) => {
    return (SessionUserSelectors.isSessionServerAdmin(state) ||
      SiteRolesUtil.isSiteAdmin(SessionSiteSelectors.siteRole(state)) ||
      getOwnerIdForView(targetItems[0]) === SessionUserSelectors.sessionUserId(state))
      && (availableActions && availableActions.whoHasSeenThisView);
  },
  createReduxAction: (targetItems: IContentInfo[]) => whoHasSeenThisView(targetItems[0])
};
